import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sort"
export default class extends Controller {
  static targets = ["sort", "hiddenField"];

  submitForm(event) {
    this.sortTarget.value = event.currentTarget.value;
    this.sortTarget.form.requestSubmit();
  }
  // ソートボタンをクリックしたときに呼び出される
  updateHiddenField(event) {
    const sValue = event.target.dataset.sValue; // ソートボタンのデータ属性から値を取得
    const hiddenField = this.hiddenFieldTarget; // hidden_field を取得
    hiddenField.value = sValue; // hidden_field の値を更新
  }
}
